import { render, staticRenderFns } from "./Perfis.vue?vue&type=template&id=328b03b8&scoped=true&"
import script from "./Perfis.vue?vue&type=script&lang=js&"
export * from "./Perfis.vue?vue&type=script&lang=js&"
import style0 from "./Perfis.vue?vue&type=style&index=0&id=328b03b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328b03b8",
  null
  
)

export default component.exports